"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Languages = void 0;
class Languages {
}
exports.Languages = Languages;
//# sourceMappingURL=languages.js.map